import React from "react";

export default function ErrorLabel({formik, field}) {
  if (formik.touched && formik.errors && formik.touched[field] && formik.errors[field])
    return <small className={'font-italic text-danger pl-1'}>{formik.errors[field]}</small>
  return null
}